import * as Yup from "yup";
import { TStep } from "../types";
import { methodOfContact } from "./questionOptions";

export const ineligibleSteps: {
  [key: string]: TStep;
} = {
  "ineligible-step-two": {
    title: "Briefly describe your concern",
    type: "form",
    components: [
      {
        type: "textarea",
        name: "concernDescription",
        validation: Yup.string()
          .max(1000, "Over character limit")
          .required("Please write some details about your concern"),
      },
    ],
    next: "ineligible-step-three",
    previous: "ineligible-step-one",
    submit: false,
    stepNumber: "12.2",
  },
  "ineligible-step-three": {
    title: "Please provide your details",
    note: ` We will use this information to contact you and to make sure we don’t have a conflict of interest,
    so we can help you with your concern.`,
    type: "form",
    components: [
      {
        label: "Given name*",
        type: "text",
        name: "contactFirstName",
        validation: Yup.string().required("Please enter given name"),
      },
      {
        label: "Family name*",
        type: "text",
        name: "contactLastName",
        validation: Yup.string().required("Please enter family name"),
      },
      {
        label: "Email*",
        type: "email",
        name: "contactEmail",
        validation: Yup.string().required("Please enter valid email").email("Please enter valid email"),
      },
      {
        label: "Contact number*",
        type: "tel",
        name: "contactNumber",
        validation: Yup.string()
          .required("Please enter valid phone number, including area code")
          .matches(
            /^\(?([0-9]{3})\)?([0-9]{3})([0-9]{4})$/,
            "Please enter valid phone number, including area code"
          ),
      },
      {
        label: "Preferred method of contact",
        type: "select",
        options: methodOfContact,
        name: "preferredContactMethod",
      },
    ],
    next: "/apply/no/mistake",
    previous: "ineligible-step-two",
    submit: true,
    stepNumber: "12.3",
  },
};
